import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { getNotificationRequest } from "../../redux/Notification/notificationSlice";
import { useAppTheme } from "../../theme/useAppTheme";

const Notification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.notification || {});

  useEffect(() => {
    dispatch(getNotificationRequest());
  }, [dispatch]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return date.toLocaleString("en-US", options);
  };

  const themeColors = useAppTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: themeColors.scaffoldGradientColors,
        border: `1px solid ${themeColors.scaffold}`,
        color: themeColors.primary,
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pb: 0,
        overflow: "hidden",
        maxWidth: 1350,
        mx: "auto",
        borderRadius: "30px",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          width: "100%",
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ color: themeColors.primary }}
        >
          <ArrowBackIcon sx={{ fontSize: 28 }} />
        </IconButton>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            ml: 1,
            textTransform: "uppercase",
          }}
        >
          Notification
        </Typography>
      </Box>

      {/* Notification Cards */}
      {data?.map((item, index) => (
        <Card
          key={index}
          sx={{
            mb: 2,
            borderRadius: "12px",
            background: themeColors.mediumContainer,
            border: `1px solid ${themeColors.scaffold}`,
            color: themeColors.text,
            overflow: "hidden",
            width: "70%",
            display: "flex",
          }}
        >
          {item.url && (
            <CardMedia
              component="img"
              image={item.url}
              alt="Notification"
              sx={{
                width: "60%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}
          <CardContent sx={{ flex: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  fontSize: "20px",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: themeColors.text,
                  fontSize: "16px",
                }}
              >
                {formatDate(item.scheduleAt)}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ fontSize: "17px", mt: 0.5 }}>
              {item.body}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default Notification;
